/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { Input } from "./input";
import { Button } from "./button";
import {
  AttachmentService,
  AttachmentType,
  type AttachmentDetails,
} from "@/services/AttachmenteService";
import FileProgressSpinner from "../FileProgressSpinner";

interface FileUploadMainProps {
  featureId: string;
  showMainImage?: boolean;
  onUploadComplete?: (attachmetnDetails: AttachmentDetails) => void;
}

const FileUploadMain: React.FC<FileUploadMainProps> = ({ featureId, showMainImage = true, onUploadComplete }) => {
  const [featureMainImageFile, setFeatureMainImageFile] = useState<any>(null);
  const [selectedMainImage, setSelectedMainImage] = useState<string | null>(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (event: any) => {
    setFeatureMainImageFile(event.target.files[0]);
  };

  useEffect(() => {
    const fetchAttments = async () => {
      try {
        if (featureId) {
          const attachments = await AttachmentService.getByEntityId(featureId);
          const mainImage = attachments.find(
            (att) => att.type === AttachmentType.Main
          );
          setSelectedMainImage(mainImage ? mainImage.url : null);
        }
      } catch (error) {
        console.error("Error fetching attachments", error);
      }
    };

    fetchAttments();
  }, [featureId]);

  const onHandleFeatureImageUpload = async () => {
    if (!featureMainImageFile) {
      alert("Please select a file first!");
      return;
    }

    // Create FormData object to hold the file
    const formData = new FormData();
    formData.append("file", featureMainImageFile); // 'file' is the key expected by the server
    setIsUploading(true);
    AttachmentService.uploadMainImage(featureId, formData)
      .then((a) => {
        setFeatureMainImageFile(null);
        setSelectedMainImage(a.url);
        if (onUploadComplete) {
          onUploadComplete(a);
        }
      })
      .catch((e) => {
        console.error("Error uploading main feature file", e);
      })
      .finally(() => {
        setIsUploading(false);
      });
  };

  return (
    <>
      {isUploading ? (
        <FileProgressSpinner />
      ) : (
        <>
          <Input type="file" onChange={handleFileChange} />
          <Button
            size="sm"
            disabled={featureMainImageFile == null || undefined}
            onClick={onHandleFeatureImageUpload}
            className="bg-green-400 md:max-w-[250px]"
          >
            Upload File
          </Button>{" "}
        </>
      )}

      {selectedMainImage && showMainImage && (
        <div className="pt-1 md:max-w-[250px]">
          <img
            src={selectedMainImage}
            className="rounded-lg"
            title="main feature image"
          />
        </div>
      )}
    </>
  );
};

export default FileUploadMain;
